module.exports = __webpack_public_path__ + "static/media/Agent3.b90c978c.jpg";